import axios from './_axios';
import entrypoints from './_entrypoints';
import { dateToApiDate, getData, reduceToNewspapers } from '../shared/functions';
/**
 * API call to retrieve a collection of newspapers
 * @return {Promise<Newspaper[]>}
 */
var getNewspapersByMonthAndPublication = function (date, publicationId) { return axios
    .get(entrypoints.newspaper, { params: { date: dateToApiDate(date), id: publicationId, monthly: true } })
    .then(getData)
    .then(reduceToNewspapers(false))
    .then(function (newspapers) { return newspapers.reverse(); }); }; // reverse since the newspapers arrive in an array with latest newspaper first
export default getNewspapersByMonthAndPublication;
